import { Model } from 'pinia-orm';
export default class InterimUser extends Model {

    static get entity () {
        return 'interim-users';
    }

    static fields () {
        return {
            id: this.uid(() => null),
            name: this.attr(() => ''),
            email: this.attr(() => ''),
            language: this.attr(() => ''),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }
}
